import Model from "@/models/Model";
import User from "@/models/User";

export default class UserClass extends Model {
    resource() {
        return "shared-classes";
    }

    users() {
        return this.hasMany(User);
    }
}
